import { Group, Paper, Stack, Text } from '@mantine/core';
import { SearchInput, UsersTable } from '../../../components';
import { useUsers } from '../../../queries/use-users';
import { useTableState } from '../../../hooks/use-table-state';
import { PAGE_SIZE } from '../../../magic-values';

interface UsersTabProps {
  accountId: string;
}

export function UsersTab({ accountId }: UsersTabProps) {
  const { page, sortBy, sortDir, sortStatus, filterBy, setPage, setSortStatus, setFilterBy } =
    useTableState();
  const { data, isLoading, isError, error } = useUsers(
    filterBy ? { accountId, filterBy } : { accountId },
    { page, pageSize: PAGE_SIZE, sortBy, sortDir },
  );
  const users = data?.items ?? [];

  return (
    <Stack spacing="sm">
      <Group position="right">
        <SearchInput value={filterBy} onChange={setFilterBy} placeholder="Search users…" />
      </Group>
      {isError ? (
        <Text color="red">
          Failed to load users: {(error as Error)?.message ?? 'Unknown error'}
        </Text>
      ) : (
        <Paper withBorder sx={{ overflowX: 'auto' }}>
          <UsersTable
            users={users}
            fetching={isLoading}
            showAccount={false}
            page={page}
            totalRecords={data?.total ?? 0}
            onPageChange={setPage}
            sortStatus={sortStatus}
            onSortStatusChange={setSortStatus}
            height="calc(100vh - 500px)"
          />
        </Paper>
      )}
    </Stack>
  );
}
